import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from './useAuth';

export function useIsAdmin() {
  const { user } = useAuth();
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    if (!user) { setIsAdmin(false); setLoading(false); return; }
    setLoading(true);
    supabase.rpc('is_admin').then(({ data }) => {
      if (!active) return;
      setIsAdmin(Boolean(data));
      setLoading(false);
    });
    return () => { active = false; };
  }, [user]);

  return { isAdmin, loading };
}